/**
 * Returns the base query key used by all comment domain hooks
 */
export function getQueryKey() {
  return ["comments"];
}
